module.exports = __webpack_public_path__ + "static/offer-m-5-feab695800a4448515d9066aed311ad7.jpg";